import { useTranslation } from 'react-i18next';
import { Button, Box } from '@mui/material';

// Define languages
const lngs = {
    en: { nativeName: 'EN' },
    vi: { nativeName: 'VI' }
};

const SwitchLngs = () => {
    const { i18n } = useTranslation();
    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mr: 1, mt: 1 }}>
          {Object.keys(lngs).map((lng) => (
            <Button 
              variant={i18n.resolvedLanguage === lng ? 'contained' : 'outlined'} 
              sx={{ marginRight: '0.5em', fontSize: { xs: '12px', sm: '14px' }, minWidth: { xs: '40px', sm: '64px'} }} 
              key={lng} 
              type="submit" 
              onClick={() => i18n.changeLanguage(lng)}
              >
              {lngs[lng].nativeName}
            </Button>
          ))}
        </Box>
    )
}

export default SwitchLngs;